// Ham fetch kullanan sayfalar icin ortak istek basliklari.
// Her sayfa kendi getAuthHeaders() kopyasini tasiyordu; aktif magaza basligi
// (X-Shop-Id) tek yerden eklensin diye burada toplandi.

// NOT: Sayfalardaki eski yerel yardimcilarla ayni fallback korunur
// (yerel gelistirmede VITE_API_URL bos ise 3001'e gider).
export function getBackendUrl() {
  return import.meta.env.VITE_API_URL || "http://localhost:3001";
}

// localStorage'dan okunur ki store'a bagimlilik olusmasin (store da ayni
// anahtari yazar). Bos ise backend varsayilan magazayi kullanir.
export function getActiveShopId(): string {
  return localStorage.getItem("erc_active_shop") || "";
}

export function authHeaders(extra?: Record<string, string>): Record<string, string> {
  const shopId = getActiveShopId();
  return {
    Authorization: `Bearer ${localStorage.getItem("erc_token") || ""}`,
    "Content-Type": "application/json",
    ...(shopId ? { "X-Shop-Id": shopId } : {}),
    ...extra,
  };
}
